const languagesActionTypes =  {    
    RETRIEVED_PAGE_LANGUAGES: "RETRIEVED_PAGE_LANGUAGES",
    RETRIEVED_SITESETTINGS_LANGUAGE_SETTINGS: "RETRIEVED_SITESETTINGS_LANGUAGE_SETTINGS"
};
export default languagesActionTypes;
